import React from 'react';
import { EmptyState } from '../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { UnrealizedGainLossDetailsSkeleton } from './UnrealizedGainLossDetailsSkeleton';

interface Props {
  title: string;
}

export const UnrealizedGainLossDetailsEmpty = ({ title }: Props) => {
  return (
    <UnrealizedGainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </UnrealizedGainLossDetailsSkeleton>
  );
};
